import { useState } from "react";
import { useGetCocktailsQuery } from "../../../../services/cocktail";
import { ModalButton } from "../../../Controls/Buttons/ModalButton";
import { StyledIonCheckbox } from "../../../Controls/Inputs/CheckboxSelect";
import Input from "../../../Controls/Inputs/Input";
import Loader from "../../../Controls/Loader/Loader";
import { QuizButtonsWrapper } from "../../../Quizzes/Quiz/QuizButtonsWrapper";
import { NotFoundText } from "../CocktailsFiltersModal";
import { Magnifier } from "../../../Icons/Magnifier";
import { difficultyLevel } from "../../../../helpers/filtersHelpers";
import { useCocktailsContext } from "../../../../hooks/useAppContext";

interface GlassTypeProps {
    choicesCocktails: number[];
    setOpenModal: (isOpen: boolean) => void;
}

const DifficultLevel = (props: GlassTypeProps) => {
    const { setOpenModal, choicesCocktails } = props;
    const [searchDifficultLevelValue, setSearchDifficultLevelTypeValue] =
        useState("");
    const [choiceCocktails, setChoiceCocktails] = useState(choicesCocktails);
    const { dispatch, state } = useCocktailsContext();
    const data = () => {
        if (searchDifficultLevelValue !== "") {
            return difficultyLevel.data.filter((item) =>
                item.name
                    .toLowerCase()
                    .includes(searchDifficultLevelValue.toLowerCase())
            );
        } else {
            return difficultyLevel.data;
        }
    };

    const { data: cocktailsData, isFetching: fetchingData } =
        useGetCocktailsQuery({
            search: state.search,
            difficulty_level_ids:
                choiceCocktails.length > 0 ? choiceCocktails : undefined,
            per_page: 50,
        });

    const handleShowResult = () => {
        dispatch({
            type: "FILTER_BY_DIFFICULTY_LEVEL",
            payload: choiceCocktails,
        });
        setOpenModal(false);
    };

    const handleCheckCategory = (id: number) => {
        setChoiceCocktails((choiceCocktails) => {
            if (choiceCocktails.includes(id)) {
                return choiceCocktails.filter((cocktail) => cocktail !== id);
            } else {
                return [...choiceCocktails, id];
            }
        });
    };

    return (
        <>
            <Input
                icon={<Magnifier height={25} />}
                type="text"
                value={searchDifficultLevelValue}
                placeholder="Znajdź poziom trudności"
                onChange={(value) => setSearchDifficultLevelTypeValue(value)}
                marginBottom={16}
            />
            {!data ? (
                <Loader fullScreen />
            ) : data ? (
                data().map((level) => (
                    <StyledIonCheckbox
                        key={level.id}
                        onIonChange={() => handleCheckCategory(level.id)}
                        labelPlacement="end"
                        checked={choiceCocktails.some(
                            (item) => item === level.id
                        )}
                    >
                        {level.name}
                    </StyledIonCheckbox>
                ))
            ) : null}
            {data().length === 0 && (
                <NotFoundText>{`Nie znalezionio typu poziomu trudności o nazwie ${searchDifficultLevelValue}`}</NotFoundText>
            )}

            <QuizButtonsWrapper>
                <ModalButton
                    color={"white"}
                    onClick={() => setChoiceCocktails([])}
                >
                    wyczyść
                </ModalButton>
                <ModalButton
                    disabled={fetchingData || !cocktailsData?.meta.total}
                    onClick={handleShowResult}
                >
                    {fetchingData ? (
                        <Loader />
                    ) : (
                        `wyświetl (${cocktailsData?.meta.total ?? "0"})`
                    )}
                </ModalButton>
            </QuizButtonsWrapper>
        </>
    );
};

export default DifficultLevel;
